export function GetTenantUrl(): string {
  return window.location.hostname
    .trim()
    .toLowerCase()
    .replace(/^www\./, "");
}
